import { useEffect, useState } from 'react';

/**
 * Modale de mise à jour, détection FIABLE (indépendante du cycle de vie capricieux
 * du service worker) : la PWA compare en continu son identifiant de build embarqué
 * (__BUILD_ID__) au fichier version.json servi à la racine (toujours frais, hors
 * précache). Dès qu'ils diffèrent, une nouvelle version est déployée -> modale.
 *
 * Le clic force la mise à jour proprement : désinscription du service worker +
 * purge des caches + rechargement. Garantit la dernière version, sans Cmd+Shift+R.
 */
export function MajPwa() {
  const [nouvelle, setNouvelle] = useState(false);
  const [enCours, setEnCours] = useState(false);

  useEffect(() => {
    let actif = true;
    const verifier = async () => {
      try {
        const res = await fetch(`/version.json?cb=${Date.now()}`, { cache: 'no-store' });
        if (!res.ok) return;
        const data = (await res.json()) as { build?: string };
        if (actif && data.build && data.build !== __BUILD_ID__) setNouvelle(true);
      } catch {
        /* hors-ligne : on réessaiera */
      }
    };
    void verifier();
    const t = setInterval(verifier, 30_000);
    // Plusieurs réveils, pas seulement l'interval (gelé en PWA standalone iOS en veille)
    // ni la seule visibilité : on revérifie aussi au focus fenêtre et au retour réseau,
    // pour ne pas rester figé sur une vieille version (bug observé).
    const surReveil = () => void verifier();
    document.addEventListener('visibilitychange', surReveil);
    window.addEventListener('focus', surReveil);
    window.addEventListener('online', surReveil);
    return () => {
      actif = false;
      clearInterval(t);
      document.removeEventListener('visibilitychange', surReveil);
      window.removeEventListener('focus', surReveil);
      window.removeEventListener('online', surReveil);
    };
  }, []);

  async function appliquer() {
    setEnCours(true);
    try {
      const regs = (await navigator.serviceWorker?.getRegistrations()) ?? [];
      await Promise.all(regs.map((r) => r.unregister()));
      if (window.caches) {
        const cles = await caches.keys();
        await Promise.all(cles.map((k) => caches.delete(k)));
      }
    } catch {
      /* on recharge quand même */
    }
    window.location.reload();
  }

  if (!nouvelle) return null;
  return (
    <div className="maj-overlay" role="dialog" aria-modal="true" aria-labelledby="maj-titre">
      <div className="maj-modale">
        <h2 id="maj-titre" className="maj-titre">
          Nouvelle version disponible
        </h2>
        <p className="maj-texte">Une mise à jour d'OcéRM est prête. Recharge pour en profiter.</p>
        <button
          type="button"
          className="maj-bouton"
          disabled={enCours}
          onClick={() => void appliquer()}
        >
          {enCours ? 'Mise à jour…' : 'Mettre à jour'}
        </button>
      </div>
    </div>
  );
}
